import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'

export type AberturaCompetencia = z.infer<typeof zod.AberturaCompetenciaSchema>
export type FechamentoCompetencia = z.infer<
    typeof zod.FechamentoCompetenciaSchema
>

const abertura = new ApiService<AberturaCompetencia>(
    'alteracao-competencia/abertura',
)
const fechamento = new ApiService<FechamentoCompetencia>(
    'alteracao-competencia/fechamento',
)

export interface IFechamento {
    data: string
    isNear: boolean
}

const proximoFechamento = new ApiService<IFechamento>(
    'alteracao-competencia/proximo-fechamento',
)

/** @usage softDelete */
export const alteracaoCompetencia = {
    abertura,
    fechamento,
    proximoFechamento,
}
